// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "staticPC/css/" + chunkId + "." + {"189":"8e9681a5","205":"36addce1","224":"706d324f","319":"d0fccdbb","327":"c424db87","427":"6687c0ed","506":"1a9731a0","570":"d2ea6729","606":"e1ef2930"}[chunkId] + ".css";
};